var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome",style:(_vm.mainStyle)},[_c('div',{staticClass:"welcome-main"},[_c('div',{staticClass:"welcome-main-content"},[_c('p',[_vm._v("欢迎您，"+_vm._s(_vm.userName))]),_c('p',[_vm._v(_vm._s(_vm.today))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }